export default "__VITE_ASSET__soUg6NLq__"